/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Classification_Import_Error_EmptyInputs */

const en_classification_import_error_empty = /** @type {(inputs: Classification_Import_Error_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This file has no rows to import.`)
};

const nl_classification_import_error_empty = /** @type {(inputs: Classification_Import_Error_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dit bestand bevat geen rijen om te importeren.`)
};

/**
* | output |
* | --- |
* | "This file has no rows to import." |
*
* @param {Classification_Import_Error_EmptyInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const classification_import_error_empty = /** @type {((inputs?: Classification_Import_Error_EmptyInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Classification_Import_Error_EmptyInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_classification_import_error_empty(inputs)
	return en_classification_import_error_empty(inputs)
});